<template>
  <footer class="whatsapp-onboarding-nav">
    <Button
      v-if="showBack"
      :label="t('storeParameters.services.whatsappBusinessParameter.onboarding.nav.back')"
      class="p-button-secondary p-button-outlined"
      type="button"
      @click="$emit('back')"
    />
    <div class="whatsapp-onboarding-nav__spacer" />
    <Button
      v-if="showConnect"
      :label="t('storeParameters.services.whatsappBusinessParameter.onboarding.nav.connect')"
      class="p-button-success"
      icon="fa-solid fa-arrow-up-right-from-square"
      type="button"
      :loading="connectLoading"
      @click="$emit('connect')"
    />
    <Button
      v-else-if="showNext"
      :label="nextButtonLabel"
      class="p-button-success"
      type="button"
      :disabled="!canGoNext"
      @click="$emit('next')"
    />
  </footer>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';

export default defineComponent({
  name: 'WhatsappOnboardingNav',

  components: {
    Button,
  },

  props: {
    showBack: { type: Boolean, default: false },
    showNext: { type: Boolean, default: false },
    showConnect: { type: Boolean, default: false },
    canGoNext: { type: Boolean, default: true },
    connectLoading: { type: Boolean, default: false },
    isIntroStep: { type: Boolean, default: false },
  },

  emits: ['back', 'next', 'connect'],

  setup(props) {
    const { t } = useI18n();

    const nextButtonLabel = computed(() => (
      props.isIntroStep
        ? t('storeParameters.services.whatsappBusinessParameter.onboarding.intro.cta')
        : t('storeParameters.services.whatsappBusinessParameter.onboarding.nav.next')
    ));

    return {
      t,
      nextButtonLabel,
    };
  },
});
</script>
